import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogContent,
} from "@mui/material";
//Import from project
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { DialogTitleComp } from "../../Utils/Component";
import { CREATE_INSTITUTE_OR_UNIVERSITY, UPDATE_INSTITUTE_OR_UNIVERSITY } from "../../Schema/InstituteOrUniversity";

export default function InstituteOrUniversityForm({ 
  open,
  editData,
  setRefetch,
  dialogTitle,
  handleClose,
  hideBackdrop,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // ================================= End upload Image ===============================

  const [createInstituteOrUniversity] = useMutation(CREATE_INSTITUTE_OR_UNIVERSITY, {
    onCompleted: ({ createInstituteOrUniversity }) => {
      setLoading(false);
      if (createInstituteOrUniversity?.isSuccess === true) {
        setAlert(true, "success", createInstituteOrUniversity?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createInstituteOrUniversity?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });
 
  const [updateInstituteOrUniversity] = useMutation(UPDATE_INSTITUTE_OR_UNIVERSITY, {
    onCompleted: ({ updateInstituteOrUniversity }) => {
      setLoading(false); 
      if (updateInstituteOrUniversity?.isSuccess === true) {
        setAlert(true, "success", updateInstituteOrUniversity?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateInstituteOrUniversity?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    nameEng: Yup.string().required(t("required")),
    nameKh: Yup.string().required(t("required")),
  });

  const formik = useFormik({
    initialValues: {
      nameEng: "",
      nameKh: ""
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Create") {
        createInstituteOrUniversity({
          variables: {
            input: {
              ...values,
            },
          },
        });
      } else {
        updateInstituteOrUniversity({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("nameKh", editData?.nameKh);
      setFieldValue("nameEng", editData?.nameEng);
    }
  }, [editData, open]);

  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth="xs"
      className="dialog-container"
      hideBackdrop={hideBackdrop}
    >
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_institute_or_university")
            : t("modal_title_update_institute_or_university")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>


              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_name")}(KH)
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_name")}
                  {...getFieldProps("nameKh")}
                  error={Boolean(touched.nameKh && errors.nameKh)}
                  helperText={touched.nameKh && errors.nameKh}
                />
              </Grid>



              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_name")}(ENG)
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_name")}
                  {...getFieldProps("nameEng")}
                  error={Boolean(touched.nameEng && errors.nameEng)}
                  helperText={touched.nameEng && errors.nameEng}
                />
              </Grid>


              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Create" ? t("create") : t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
